import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { HeartPulse, Moon, BrainCircuit } from 'lucide-react';
export const ProblemSection = () => {
  return <Section variant="navy" data-id="element-122">
      <FadeIn data-id="element-123">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-124">
          La ansiedad no es un concepto abstracto;{' '}
          <span className="text-gold italic" data-id="element-125">es física.</span>
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-126">
        <FadeIn delay={0.1} className="bg-navy-light p-8 rounded-2xl border border-navy-light hover:border-gold/20 transition-colors" data-id="element-127">
          <HeartPulse className="w-10 h-10 text-gold mb-6" data-id="element-128" />
          <p className="text-lg text-cream-muted" data-id="element-129">
            Es un nudo en la garganta al despertar y manos sudorosas antes de
            una reunión.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} className="bg-navy-light p-8 rounded-2xl border border-navy-light hover:border-gold/20 transition-colors" data-id="element-130">
          <Moon className="w-10 h-10 text-gold mb-6" data-id="element-131" />
          <p className="text-lg text-cream-muted" data-id="element-132">
            Es un insomnio voraz que te hace juzgar cada error de tu pasado en
            la madrugada.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} className="bg-navy-light p-8 rounded-2xl border border-navy-light hover:border-gold/20 transition-colors" data-id="element-133">
          <BrainCircuit className="w-10 h-10 text-gold mb-6" data-id="element-134" />
          <p className="text-lg text-cream-muted" data-id="element-135">
            Estás atrapado en un ciclo de alerta roja constante, donde tu mente
            no se detiene.
          </p>
        </FadeIn>
      </div>

      <FadeIn delay={0.4} className="max-w-2xl mx-auto text-center" data-id="element-136">
        <p className="text-xl leading-relaxed text-cream-muted" data-id="element-137">
          Intentas orar, pero las palabras no salen. Intentas leer la Biblia,
          pero no sabes por dónde empezar cuando sientes que te falta el aire.
          Te sientes culpable por tener miedo, y esa culpa solo alimenta más la
          ansiedad.
        </p>
      </FadeIn>
    </Section>;
};